import React from "react";
import CookieProvider from "./cookie-providers";
import SalesforceProvider from "./salesforce-provider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// NOTE: I would really like to remove the global prop from this component
export default function Providers({
  children,
  global,
}: {
  children: React.ReactNode;
  global: any;
}) {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
          },
        },
      }),
  );

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <SalesforceProvider enabled={global?.attributes?.webLiveChat}>
          {children}
          <CookieProvider />
        </SalesforceProvider>
      </QueryClientProvider>
    </>
  );
}
